import { useQuery } from "react-query";
import { get } from "shared/data";

export const useCustomSla = () => {
    return useQuery("customSla", {
        queryFn: () => get("/sla/custom"),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
